import setAgentPreferences from 'actions/agent_preferences/set_agent_preferences';

export default class MarkFeatureAsSeen {
  constructor(context) {
    this.context = context;
  }

  run({ id }) {
    const agentPreferences = this.context.stores.agentPreferences.get();
    agentPreferences.markFeatureAsSeen(id);
    setAgentPreferences(this.context, agentPreferences);
  }
}
